// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quotas__auth .t-popup__content{background:none;box-shadow:none;padding:0}.quotas__auth .auth-template{position:relative;top:auto;left:auto;margin-top:0;transform:translate(0, 0)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
